<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_DEPARTMENT_ADD"
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_DEPARTMENT_DEL"
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_DEPARTMENT_DEL_TRUE"
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_DEPARTMENT_EDIT"
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
        </template>
        <template slot-scope="scope" slot="superiorId">
          <el-tag v-if="null != scope.row.superiorName">{{scope.row.superiorName}}</el-tag>
        </template>
        <template slot-scope="scope" slot="dutyStuff">
          <el-tag v-if="null != scope.row.dutyStuff">{{scope.row.dutyStuff}}</el-tag>
        </template>
        <template slot-scope="scope" slot="superiorIdForm">
          <el-select
            v-model="superior"
            placeholder="请选择上级部门"
            required
            @change="chooseSuperior"
            value-key="id"
          >
            <el-option
              v-for="superior in superiors"
              :key="superior.id"
              :label="superior.name"
              :value="superior"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="dutyStuffForm">
          <el-select v-model="dutyStuff" placeholder="请选择部门负责人" required value-key="id">
            <el-option
              v-for="dutyStuff in dutyStuffs"
              :key="dutyStuff.id"
              :label="dutyStuff.name"
              :value="dutyStuff"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="menuIdsForm">
          <el-tree
            :data="selectRolePermissions"
            ref="tree"
            default-expand-all
            show-checkbox
            check-strictly
            node-key="id"
          ></el-tree>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { departmentTableOption } from "@/const/salesCloud/departmentOption";
import {
  findDepartment,
  addDepartment,
  editDepartment,
  delDepartment,
  findDepartmentAll,
  findDepartmentDetail
} from "@/api/salesCloud/department";
import { findStuffAll } from "@/api/salesCloud/stuff";
import { getUserPermissionMenusOperation } from "@/api/salesCloud/menu";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "department",
  components: {},
  data() {
    return {
      tableOption: departmentTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      selectRolePermissions: [],
      superiors: [],
      superior: {},
      dutyStuffs: [],
      dutyStuff: {}
    };
  },
  created() {
    this.handleList();
    // 查询部门
    findDepartmentAll().then(res => {
      let data = JSON.parse(res.data);
      this.superiors = data;
    });
    findStuffAll().then(res => {
      let data = JSON.parse(res.data);
      this.dutyStuffs = data;
      console.log('~~~~',this.dutyStuffs);
    });

    getUserPermissionMenusOperation().then(res => {
      let data = JSON.parse(res.data);
      this.selectRolePermissions = data;
    });
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    chooseSuperior() {
        this.dutyStuff = ""
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findDepartment(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findDepartment(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findDepartment(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findDepartment(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      let _this = this;
      findDepartmentDetail(row.id).then(res => {
        let page = JSON.parse(res.data);
        let data = page.rows[0];
        this.superior = {
          id: data.superiorId
        };
        if (null != data.dutyStuff) {
          this.dutyStuff = {
            id: data.dutyStuff
          };
        }
        _this.$refs.tree.setCheckedKeys(data.menuIds, true);
        row = data;
        console.log("row：" + JSON.stringify(row));
      });
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findDepartment(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      let checkKeys = [].concat(
        this.$refs.tree.getHalfCheckedKeys(),
        this.$refs.tree.getCheckedKeys()
      );
      row.menuIds = checkKeys;
      row.superiorId = this.superior.id;
      row.dutyStuff = this.dutyStuff.id;

      addDepartment(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delDepartment(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      let checkKeys = [].concat(
        this.$refs.tree.getHalfCheckedKeys(),
        this.$refs.tree.getCheckedKeys()
      );
      row.menuIds = checkKeys;
      row.superiorId = this.superior.id;
      row.dutyStuff = this.dutyStuff.id;
      editDepartment(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "编辑成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
